import { getProgress, useGetApiAdminSyncStatus } from '@sit/client-shared';
import Box from 'carbon-react/lib/components/box';
import Message from 'carbon-react/lib/components/message';
import { addMinutes } from 'date-fns';
import { useState } from 'react';
import { ProgressBar } from '../../components/ProgressBar';
import { Sequence } from './Sequence';
import { Steps } from './steps';

export interface Step1SyncProps {
  entityIds: string[];
  companyTreeSettingsId: number;
  onSuccess: () => void;
}

function Step1Sync({ companyTreeSettingsId, onSuccess }: Step1SyncProps) {
  const [error, setError] = useState<any>();
  // eslint-disable-next-line @eslint-react/naming-convention/use-state -- don't need setter
  const [now] = useState<number>(() => Date.now());

  const { data: syncStatusData } = useGetApiAdminSyncStatus(
    {
      pathParams: {
        companyTreeSettingsId: `${companyTreeSettingsId}`,
      },
      queryParams: {
        isInitial: 'true',
      },
    },
    {
      refetchInterval: (query) => {
        if (!query.state.data) return false;
        if (getProgress(query.state.data) === 100) {
          onSuccess();
          return false;
        }
        return 2500;
      },
      retry: (failureCount, error) => {
        if (!(error instanceof Error)) {
          return false;
        }
        if (error.message?.includes('Too many requests') || failureCount < 5) {
          return true;
        }
        setError(error.message);
        return false;
      },
    },
  );

  const progress = syncStatusData ? getProgress(syncStatusData) : 0;
  const approximateCompletionTime = addMinutes(now, 5 * (1 - progress / 100));

  return (
    <div className="provision">
      <div className="card">
        <Box pb={4}>
          <Sequence step={Steps.SYNC} />
        </Box>
        <div className="subtitle">
          <span>
            We're currently connecting to your Intacct instance. This usually
            takes no more than 5 minutes per Intacct entity. You can view the
            progress of the connection via the progress bar below. We will also
            email you when the connection is complete.
          </span>
        </div>
        <ProgressBar
          now={progress}
          approximateCompletionTime={approximateCompletionTime}
        />
        {!!error && (
          <Box mt="10px">
            <Message variant="error">{error}</Message>
          </Box>
        )}
      </div>
    </div>
  );
}

export default Step1Sync;
